export enum ToolbarCustomButtonType {
  name = "name",
  link = "link",
  field = "field",
}

export type ToolbarCustomButton = { type?: ToolbarCustomButtonType; component?: React.ReactNode };
